import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateHostelRoom = async (HostelObject, uid, SchoolID) => {
  try {
    const HostelCollection = collection(db, "Hostel");

    const data = HelperForMetaData({
      ...HostelObject,
      uid: uid,
      SchoolID: SchoolID,
    });
    await addDoc(HostelCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateHostelRoom;
